import { withInstall } from 'framework/utils'

import appProvider from './src/AppProvider.vue'

export const AppProvider = withInstall(appProvider)
export { useAppProviderContext } from './src/useAppContext'
